import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import CurrencyInput from "react-currency-masked-input";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";

import { getLocalisationVal, transformInput } from "@/utils/localizationUtil";
import { Colors } from "@/theme";
import useStyles from "./styles";

const ProductCard = ({ product, isLast, localization, onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box
      borderRight={isLast ? "none" : `1px solid ${Colors.GRAY_BORDER}`}
      paddingX={10}
      marginBottom={10}
    >
      <Box textAlign={"center"}>
        <span className={classes.codeText}>{product.product_code}</span>
      </Box>
      <Box mt={5} textAlign={"center"}>
        <span className={classes.labelText}>
          {t("purchase_screen.purchase_price")}
        </span>
      </Box>
      <Box margin={"auto"} mt={3}>
        <CurrencyInput
          value={getLocalisationVal(localization, product.purchase_price)}
          onChange={(e, value) =>
            onChange("purchase_price", transformInput(localization, value))
          }
          className={classes.currencyInput}
          type=""
          separator={localization.digit_separator === "," ? "." : ","}
        />
      </Box>
      {product.stock_types?.map((stock_type) => (
        <Box key={`${product.id}-${stock_type.id}`}>
          <Box mt={5} textAlign={"center"}>
            <span className={classes.labelText}>
              {t("purchase_screen.delivery_in_litre", {
                stock_type: stock_type.name,
              })}
            </span>
          </Box>
          <Box margin={"auto"} mt={3}>
            <CurrencyInput
              value={getLocalisationVal(localization, stock_type.amount)}
              onChange={(e, value) => {
                const newStockTypes = product.stock_types.map((item) =>
                  item.id === stock_type.id
                    ? { ...item, amount: transformInput(localization, value) }
                    : item
                );
                onChange("stock_types", newStockTypes);
              }}
              className={classes.currencyInput}
              type=""
              separator={localization.digit_separator === "," ? "." : ","}
            />
          </Box>
        </Box>
      ))}

      <Box mt={5} textAlign={"center"}>
        <span className={classes.labelText}>
          {t("purchase_screen.date_time")}
        </span>
      </Box>
      <Box margin={"auto"} mt={3}>
        <MobileDateTimePicker
          value={product.time}
          onChange={(value) => onChange("time", value)}
          format="DD MMM HH:mm"
          className={classes.input}
        />
      </Box>
    </Box>
  );
};

export default ProductCard;
